export const defaultMaintenanceConfig = {
    login_disabled: false,
    notifications_disabled: false,
    part_offers_disabled: false,
    part_requests_disabled: false,
    signup_disabled: false,
};
